module.exports = __webpack_public_path__ + "static/img/home.1ca0d2ec.svg";